/**
 * 상품 목록 빈 상태 컴포넌트
 *
 * 3가지 상태: 검색 결과 없음, 카테고리에 상품 없음, 로딩 에러
 */
import { AlertCircle, PackageOpen, SearchX } from "lucide-react";

import { Button } from "@/components/ui/button";

type EmptyViewVariant = "no-results" | "no-search-results" | "error";

interface EmptyViewProps {
  variant: EmptyViewVariant;
  keyword?: string;
  onReset?: () => void;
}

const CONTENT: Record<EmptyViewVariant, { icon: typeof SearchX; title: string }> = {
  "no-results": {
    icon: PackageOpen,
    title: "해당 조건의 상품이 없습니다",
  },
  "no-search-results": {
    icon: SearchX,
    title: "검색 결과가 없습니다",
  },
  error: {
    icon: AlertCircle,
    title: "상품을 불러오는 중 오류가 발생했습니다",
  },
};

export function EmptyView({ variant, keyword, onReset }: EmptyViewProps) {
  const { icon: Icon, title } = CONTENT[variant];

  return (
    <div className="flex flex-col items-center gap-4 text-center pt-24 pb-16">
      <Icon className="h-12 w-12 text-muted-foreground/50" strokeWidth={1.5} />
      <div className="space-y-1">
        <p className="text-base font-medium text-foreground">{title}</p>
        {variant === "no-search-results" && keyword && (
          <p className="text-sm text-muted-foreground">
            &ldquo;{keyword}&rdquo;에 대한 결과를 찾을 수 없습니다
          </p>
        )}
        {variant === "no-results" && (
          <p className="text-sm text-muted-foreground">필터 조건을 변경해보세요</p>
        )}
        {variant === "error" && (
          <p className="text-sm text-muted-foreground">잠시 후 다시 시도해주세요</p>
        )}
      </div>
      {onReset && (
        <Button variant="outline" size="sm" onClick={onReset}>
          {variant === "no-search-results" ? "검색 초기화" : "필터 초기화"}
        </Button>
      )}
    </div>
  );
}
